import { request } from "../../utils/config"

export const GET_NOTIFICATIONS = async (params?: {
  unreadOnly?: boolean
  /** "debt" — qarzdorliklar, "stock" — tovar qoldiqlari, bo'sh — hammasi */
  category?: string
  page?: number
  pageSize?: number
}) => {
  const response = await request({
    url: `Notifications/GetNotifications`,
    method: "GET",
    params: {
      unreadOnly: params?.unreadOnly || false,
      category: params?.category || undefined,
      page: params?.page || 1,
      pageSize: params?.pageSize || 50,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export interface AlertSettings {
  maxDebtDays: number
  maxDebtAmountUSD: number
  defaultMinStock: number
  enabled: boolean
}

export const GET_ALERT_SETTINGS = async (): Promise<AlertSettings> => {
  const response = await request({
    url: `Notifications/AlertSettings`,
    method: "GET",
    silent: true,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  const d = response.data || {}
  return {
    maxDebtDays: d.maxDebtDays ?? d.MaxDebtDays ?? 30,
    maxDebtAmountUSD: d.maxDebtAmountUSD ?? d.MaxDebtAmountUSD ?? 0,
    defaultMinStock: d.defaultMinStock ?? d.DefaultMinStock ?? 10,
    enabled: d.enabled ?? d.Enabled ?? true,
  }
}

export const UPDATE_ALERT_SETTINGS = async (data: AlertSettings) => {
  const response = await request({
    url: `Notifications/AlertSettings`,
    method: "PUT",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

/** Eslatmalarni darhol qayta hisoblash */
export const REFRESH_ALERTS = async () => {
  const response = await request({
    url: `Notifications/RefreshAlerts`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const CREATE_NOTIFICATION = async (data: {
  userId?: number
  title: string
  message: string
  type?: string
  linkUrl?: string
}) => {
  const response = await request({
    url: `Notifications/CreateNotification`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const MARK_NOTIFICATION_READ = async (id: number) => {
  const response = await request({
    url: `Notifications/MarkAsRead?id=${id}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

/**
 * Ko'rinib turgan eslatmalarni o'qilgan deb belgilaydi.
 * category berilmasa — foydalanuvchiga ko'rinadigan hammasi.
 */
export const MARK_ALL_NOTIFICATIONS_READ = async (category?: string) => {
  const response = await request({
    url: `Notifications/MarkAllAsRead`,
    method: "POST",
    params: category ? { category } : undefined,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
